export class VenderMaster {
  public ID!: number;
  public VENDOR_CODE!: string;
  public VENDOR_NAME!: string;
  public VENDOR_ADDRESS!: string;
  public CONTACT_NO!: string;
  public REMARKS!: string;
  public LEDGER_NAME!: string;
  public GST_NO!: string;
  public BANK_AC!: string;
  public BANK_NAME!: string;
  public IFSC!: string;
  public BANK_BRANCH!: string;
  public OPENING_AMT!: number;
  public DrCr!: string;
  public VENDOR_TYPE!: string;
  public VENDOR_LOC!: string;
  public CREATEDBY_USERID!: Number;
  public UPDATEDBY_USERID!: Number;
  public CREATED_DATE!: Date;
  public UPDATED_DATE!: Date;
  public IS_ACTIVE!: number;
}
